import { CustomErrorComponent } from './_error'

export default function Custom404() {
  return (
    <CustomErrorComponent
      statusCode={404}
      description="This page does not exist. You can go back to the app."
    />
  )
}
